import React from 'react';
import { Link } from 'react-router-dom';
import { Image, Alert, Form, Container } from 'react-bootstrap';
import { userService } from '../_services/user.service';
import Config from '../_core/config'
import Logo from '../korg-logo.png';
import "./Login.sass";

class Login extends React.Component {
    constructor(props) {
        super(props);

        userService.logoutUser();

        this.state = {
            email: '',
            password: '',
            submitted: false,
            loading: false,
            error: false,
            errorMessage: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { email, password } = this.state;

        // stop here if form is invalid
        if (!(email && password)) {
            return;
        }

        this.setState({ loading: true });

        userService.login(email, password)
            .then(
                user => {
                    if(user.user && user.user._id){
                        const { from } = this.props.location.state || { from: { pathname: "/" } };
                        if(email === Config.admin){
                            this.props.history.push({ pathname: "/admin/dashboard" });
                        }
                        this.props.history.push(from);
                    }else{
                        this.setState({error:true, loading:false, errorMessage: user.error.toString() || 'Login error' });
                    }
                },
                // error => {
                //     // this.setState({ error:true, errorMessage: error  })
                // }
            );
    }

    render() {
        const { email, password, submitted, loading, error, errorMessage } = this.state;
        return (
            <div className="login-bg">
                <Container className="login-container">
                    { error &&
                        <Alert variant="danger">{ errorMessage }</Alert>
                    }
                    <Form onSubmit={this.handleSubmit}>
                        <div className="logo-image">
                            <Link to="/" align="left">
                                <Image src={Logo} alt="" className="logo"/>
                                <p>PHILIPPINES</p>
                            </Link>
                        </div>
                        <h2 className="login-text">Login 
                            {loading &&
                                <Image src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                            }</h2>
                        <div className={'form-group' + (submitted && !email ? ' has-error' : '')}>
                            {/* <label htmlFor="email">Email</label> */}
                            <input type="text" className="form-control login-email" name="email" value={email} onChange={this.handleChange} placeholder="Username"/>
                            {submitted && !email &&
                                <div className="help-block">email is required</div>
                            }
                        </div>
                        <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                            {/* <label htmlFor="password">Password</label> */}
                            <input type="password" className="form-control login-pw" name="password" value={password} onChange={this.handleChange} placeholder="Password"/>
                            {submitted && !password &&
                                <div className="help-block">Password is required</div>
                            }
                        </div>
                        <div className="login-button">
                            <button className="btn btn-login" disabled={loading}>Sign in</button>
                            <Link className="login-forgot" to="/forgot-password">Forgot Password?</Link>
                        </div>
                    </Form>
                    {/* <Row>
                        <Col align="right">
                            <Link to="/signup" align="right">Register</Link>
                        </Col>
                        
                    </Row> */}
                </Container>
            </div>
        );
    }
}

export { Login };